import { render, staticRenderFns } from "./risco.vue?vue&type=template&id=e3c2cff4&"
import script from "./risco.vue?vue&type=script&lang=js&"
export * from "./risco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports